module.exports = __webpack_public_path__ + "img/cns_printer_pc21.62862329.png";